<template>
    <v-row>
        <v-col>
            <v-row>
                <v-col cols="12">
                    <base-card>
                        <v-card-title>
                            Access Restricted
                        </v-card-title>
                        <v-card-text>
                            You are not permitted to access this page.
                        </v-card-text>
                    </base-card>
                </v-col>
            </v-row>
        </v-col>
    </v-row>
</template>

<script>
export default {
    metaInfo: {
        title: 'Adpoints Management'
    }
}
</script>

<style lang="scss" scoped>
</style>
